<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
         결제관리
        </div>
        <div class="list-content">
          <payment-list-component :paymentType="'payment'"></payment-list-component>
        </div>
      </div>
        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>
import PaymentListComponent from "@/components/payment/PaymentListComponent";
export default {
  name: 'Payment',
  mixins: [],
  components: {PaymentListComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
  },
  methods: {

  },
  watch: {},
}
</script>
